import React, { useState } from 'react';
import { Button, Checkbox, Modal } from 'antd';
import styled from 'styled-components';
import Cookie from '../../assets/cookie.svg';
import cookieRepo from '../../services/repository/cookie';

const Wrapper = styled.div`
  padding: 16px;
`;

const TtileCookie = styled.h1`
  text-align: center;
`;

const ContainerImgCookie = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const ImageCookie = styled.img`
  max-width: 100%;
`;

const FooterModal = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 16px;
`;

const BodyCustomCookie = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const HyperlinkCookie = styled.a`
  text-decoration: underline;
`;

const ModalCookie = styled(Modal)`
  .ant-modal-content {
    padding: 0;
    border-radius: 12px;
  }

  .ant-modal-header {
    padding: 16px 16px;
    border-bottom: 1px solid rgb(221, 221, 221);
  }
  
  .ant-modal-body {
    border-bottom: 1px solid rgba(221, 221, 221, 1);  
  }
  
  .ant-modal-footer {
    padding: 8px 16px; 
  }
`;

const ModalCookies: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [custom, setCustom] = useState(false);

  const onAgree = () => {
    cookieRepo.accept();
    setIsModalOpen(false);
    localStorage.setItem('admissao-digital-cookie', 'true');
  };

  return (
    <ModalCookie
      centered
      title={custom && 'Personalizar Cookies'}
      open={isModalOpen}
      onOk={() => setIsModalOpen(false)}
      footer={(
        <>{custom ? (
          <FooterModal>
            <Button type={'primary'} onClick={() => setCustom(false)}>Prosseguir</Button>
          </FooterModal>
        ) : (
          <FooterModal>
            <Button onClick={() => setCustom(true)}>Personalizar</Button>
            <Button type={'primary'} onClick={onAgree}>Eu concordo</Button>
          </FooterModal>
        )}</>
      )}
      width={504}
      closable={false}
      style={{ marginTop: '16px' }}
    >
      <Wrapper>
        {custom ? (
          <BodyCustomCookie>
            <span>Cookies necessários são cookies essenciais que possibilitam a navegação em nossas aplicações e o acesso a todos os recursos,
            por este motivo não é possível realizar o acesso sem a seleção desta opção.
            Revise as opções abaixo e depois clique em prosseguir.</span>
            <Checkbox checked disabled>Apenas cookies necessários</Checkbox>
            <Checkbox>Todos os cookies</Checkbox>
          </BodyCustomCookie>
        ) : (
          <>
            <ContainerImgCookie> <ImageCookie src={Cookie} alt='Cookie' /></ContainerImgCookie>

            <TtileCookie>Olha o Cookie!!!</TtileCookie>

            <span>
          Nós usamos os cookies para melhorar sua experiência no sistema e te dar a melhor forma de serviço!
              <br />
              <br />
          Veja mais detalhes:
              {' '}
              <HyperlinkCookie
                href='https://drive.google.com/file/d/11g4nazHgxpZX5_BnblVIPuf7Z1-WNMQz/view' target='_blank'
                rel='noreferrer'>ver política de cookies</HyperlinkCookie> será possível visualizar
            os tipos de cookies que podemos utilizar. <HyperlinkCookie
                href='https://drive.google.com/file/d/1mZvk0uvEfDwX7erUw772KQ9zZfOtJjbB/view' target='_blank'
                rel='noreferrer'>Política de privacidade</HyperlinkCookie>.
            </span>
          </>
        )}
      </Wrapper>
    </ModalCookie>
  );
};
export default ModalCookies;